import { render, staticRenderFns } from "./CulturalLevel.vue?vue&type=template&id=3a07ae0d&scoped=true&"
import script from "./CulturalLevel.vue?vue&type=script&lang=js&"
export * from "./CulturalLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a07ae0d",
  null
  
)

export default component.exports